var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC843",
  d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D38700",
  d: "M12 20.555a8.556 8.556 0 1 0 0-17.11 8.556 8.556 0 0 0 0 17.11"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC843",
  d: "m12.366 7.453 1.222 2.494c.049.122.17.195.318.22l2.737.39c.342.05.465.465.22.71l-1.98 1.93a.43.43 0 0 0-.122.368l.465 2.737c.048.343-.294.587-.612.44l-2.444-1.295a.38.38 0 0 0-.391 0l-2.445 1.295c-.293.171-.66-.098-.61-.44l.464-2.737a.4.4 0 0 0-.123-.367l-1.98-1.931c-.244-.245-.122-.66.22-.71l2.738-.39a.43.43 0 0 0 .318-.22l1.222-2.494c.196-.317.636-.317.783 0"
})));
export default SvgCoin;